export default {

    namespaced: true,
  
    state: () => ({
  
      notifications: [],

    }),
  
    mutations: {
        setNotification(state, data) {
            console.log(data)
        state.notifications.push(data)
      },
    },
  
  }
  